import { ReactNode } from "react";

export interface EmptyDataScreenProps {
  className?: string;
  buttonClassName?: string;
  iconClassName?: string;
  titleClassName?: string;
  subtitleClassName?: string;
  type?: EmptyDataScreenTypes;
  isHorizontal?: boolean;
  icon?: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  buttonText?: string;
  isIconHidden?: boolean;
  isTitleHidden?: boolean;
  isSubtitleHidden?: boolean;
  onButtonClick?: () => void;
}

export enum EmptyDataScreenTypes {
  NoResults = "no-results",
  NoSearchResults = "no-search-results",
  NoSearchResultsWithFilters = "no-search-results-with-filters",
  NoResultsForFilters = "no-results-for-filters",
}
